(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.generation = (this.generation || 0) + 1;
      const generation = this.generation;
      this.endAt = parseCountdownDateTime(this.getAttribute('data-end'), this.getAttribute('data-time-zone'));
      this.nums = ['day', 'hour', 'min', 'sec'].map((name) => this.querySelector(`.${name} .num`));
      document.addEventListener('visibilitychange', this);
      this.tick(generation);
    }

    disconnectedCallback() {
      this.generation += 1;
      this.stop();
      document.removeEventListener('visibilitychange', this);
    }

    handleEvent() {
      if (document.hidden) {
        this.stop();
        return;
      }

      this.tick(this.generation);
    }

    stop() {
      clearTimeout(this.timerId);
      this.timerId = undefined;
    }

    tick(generation) {
      if (generation !== this.generation) return;

      this.stop();

      if (Number.isNaN(this.endAt) || this.nums.some((node) => !node)) return;

      const remaining = Math.max(0, this.endAt - Date.now());
      const total = Math.floor(remaining / 1000);
      const parts = [
        Math.floor(total / 86400),
        Math.floor((total % 86400) / 3600),
        Math.floor((total % 3600) / 60),
        total % 60,
      ];

      this.nums.forEach((node, index) => {
        const next = String(parts[index]).padStart(2, '0');
        if (node.textContent !== next) node.textContent = next;
      });

      if (remaining <= 0) {
        this.toggleAttribute('expired', true);
        return;
      }

      this.toggleAttribute('expired', false);
      this.timerId = setTimeout(
        () => this.tick(generation),
        Math.max(16, 1000 - (Date.now() % 1000))
      );
    }
  }

  function parseCountdownDateTime(value, timeZone) {
    if (!timeZone) return Date.parse(value);

    let timestamp = Date.parse(`${value}Z`);
    if (Number.isNaN(timestamp)) return timestamp;

    const formatter = new Intl.DateTimeFormat('en', { timeZone, timeZoneName: 'longOffset' });
    for (let pass = 0; pass < 2; pass++) {
      const zone = formatter.formatToParts(timestamp).find((part) => part.type === 'timeZoneName');
      const offset = zone.value.replace('GMT', '') || 'Z';
      timestamp = Date.parse(`${value}${offset}`);
    }

    return timestamp;
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["back-in-stock"] && !Shopify.designMode) return;
  try {
    const KLAVIYO_SCRIPT_URL = 'https://a.klaviyo.com/media/js/onsite/onsite.js';
  const KLAVIYO_STATE_KEY = '__laFranciaBackInStock';

  const getKlaviyoState = () => {
    window[KLAVIYO_STATE_KEY] ||= {};
    return window[KLAVIYO_STATE_KEY];
  };

  const loadKlaviyo = () => {
    const state = getKlaviyoState();
    if (state.loadPromise) return state.loadPromise;

    state.loadPromise = new Promise((resolve, reject) => {
      const existingScript = document.querySelector(`script[src="${KLAVIYO_SCRIPT_URL}"]`);
      if (existingScript) {
        if (window.klaviyo) {
          resolve();
          return;
        }

        existingScript.addEventListener('load', resolve, { once: true });
        existingScript.addEventListener('error', reject, { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = KLAVIYO_SCRIPT_URL;
      script.async = true;
      script.addEventListener('load', resolve, { once: true });
      script.addEventListener('error', reject, { once: true });
      document.head.append(script);
    });

    return state.loadPromise;
  };

  const initializeKlaviyo = async (config) => {
    const state = getKlaviyoState();
    if (state.initialized) return;

    await loadKlaviyo();
    window.klaviyo ||= [];
    window.klaviyo.init({ account: config.account, platform: 'shopify' });
    window.klaviyo.enable('backinstock', {
      trigger: {
        product_page_text: config.buttonLabel,
        product_page_class: 'add-to-cart-button',
        product_page_text_align: 'center',
        product_page_margin: '0px',
        replace_anchor: false,
      },
      modal: {
        headline: config.headline,
        font_family: 'acumin-pro, sans-serif',
        body_content: config.body,
        email_field_label: config.emailLabel,
        button_label: config.submitLabel,
        subscription_success_label: config.successMessage,
        footer_content: '',
        additional_styles:
          '@font-face { font-family: "freightbigcmp-pro"; src: url("https://use.typekit.net/af/e0988e/000000000000000077587b41/31/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"); font-display: swap; font-style: normal; font-weight: 400; } #container { border-radius: 0 !important; font-family: acumin-pro, system-ui, sans-serif !important; font-size: 14px !important; font-weight: 300 !important; line-height: 1.5 !important; } #container .modal-title { font-family: freightbigcmp-pro, Georgia, serif !important; font-size: 32px !important; font-style: normal !important; font-weight: 400 !important; line-height: 1 !important; text-transform: none !important; } #container .close, #container .close span { font-family: acumin-pro, system-ui, sans-serif !important; font-weight: 300 !important; line-height: 1 !important; } #container label, #container input { font-family: acumin-pro, system-ui, sans-serif !important; font-size: 14px !important; font-weight: 300 !important; } #container input#email { border-radius: 0 !important; box-shadow: none !important; } #container .btn { border-radius: 0 !important; font-family: acumin-pro, system-ui, sans-serif !important; font-size: 14px !important; font-style: normal !important; font-weight: 300 !important; line-height: 1.5 !important; padding: 16px 24px !important; text-transform: uppercase !important; }',
        drop_background_color: config.overlayColor,
        background_color: config.backgroundColor,
        text_color: config.textColor,
        button_text_color: config.buttonTextColor,
        button_background_color: config.buttonBackgroundColor,
        close_button_color: config.closeColor,
        error_background_color: config.errorBackgroundColor,
        error_text_color: config.errorTextColor,
        success_background_color: config.successBackgroundColor,
        success_text_color: config.successTextColor,
        newsletter_subscribe_label: config.newsletterLabel,
        subscribe_checked: config.newsletterChecked,
      },
    });
    state.initialized = true;
  };

  class BackInStock extends HTMLElement {
    connectedCallback() {
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this, { attributes: true, childList: true, subtree: true });
      this.initialize();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.restoreAddToCart();
    }

    initialize = async () => {
      const configElement = this.querySelector('[data-back-in-stock-config]');
      if (!configElement?.textContent) return;

      try {
        await initializeKlaviyo(JSON.parse(configElement.textContent));
        this.sync();
      } catch {}
    };

    sync = () => {
      const productDetails = this.closest('.product-details');
      const isPrimaryBlock = productDetails?.querySelector('back-in-stock') === this;
      const trigger = this.querySelector('.klaviyo-bis-trigger');
      const shouldShow = isPrimaryBlock && trigger && getComputedStyle(trigger).display !== 'none';
      const addToCart = productDetails?.querySelector(
        `product-form-component[data-product-id="${this.dataset.productId}"] add-to-cart-component`
      );

      if (addToCart) addToCart.hidden = shouldShow;
    };

    restoreAddToCart() {
      const addToCart = this.closest('.product-details')?.querySelector('add-to-cart-component');
      if (addToCart) addToCart.hidden = false;
    }
  }

  if (!customElements.get('back-in-stock')) {
    customElements.define('back-in-stock', BackInStock);
  }
  } catch(e) { console.error(e); }
})();

})();
